<template>
  <div>
    <a-modal
      :title="`${nowObj?'编辑':'新增'}自定义字段`"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="900px"
      class="add-fields-modal"
      :centered="true"
    >
      <div class="top-info"><a-icon type="info-circle" theme="filled" />自定义指标所有人可见，他人也可引用，请确保指标的准确性，人类智慧因你而闪光。</div>
      <a-form-model
        ref="form"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="字段名称" prop="name" :rules="[
          { required: true, message: '请输入新字段的名称', trigger: 'blur' },
          { max: 100, message: '不能超过100个字符', trigger: 'blur' },
          { validator: validatorName, trigger: 'blur' },
        ]">
          <a-input v-model="form.name" placeholder="请输入新字段的名称"/>
        </a-form-model-item>
        <a-form-model-item label="字段归属" prop="tableIds" :rules="[{ required: true, message: '请选择字段归属', trigger: 'change' }]">
          <a-select v-model="form.tableIds" placeholder="请选择字段归属" @change="tableIdChange" :disabled="!!nowObj" mode="multiple">
            <a-select-option :value="v.id" v-for="v in tableList" :key="v.id">{{v.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="字段类型" prop="regulationEnum">
          <a-radio-group v-model="form.regulationEnum" @change="regulationChange">
            <a-radio :value="key" v-for="(val, key) in regulationEnum" :key="key">{{val}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <template v-if="form.regulationEnum === 'CALCULATE'">
          <a-form-model-item label="指标计算">
            <a-row>
              <a-col :span="5">
                <a-button type="primary" @click="handleAddTargetSelect">添加指标框</a-button>
              </a-col>
              <a-col :span="5">
                <a-button type="primary" @click="handleAddOpSelect">添加操作符</a-button>
              </a-col>
              <a-col :span="5">
                <a-button type="primary" @click="handleFormulaOpInput">添加输入框</a-button>
              </a-col>
              <a-col :span="5">
                <a-button type="danger" @click="handleDelFormulaOp">删除</a-button>
                <a-tooltip>
                <template slot="title">
                  按照从后到前的顺序依次删除
                </template>
                <icon-font type="icon-Question-Circle-Line" class="delete-info"/>
              </a-tooltip>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-col  :span="5" style="padding: 2px" v-for="item in formulaArrays" :key="item.value">
                  <a-input v-if="item.type == 'input'" v-model="item.formular" @blur="handleFormularChange"
                    placeholder="请输入数字"></a-input>
                  <a-select v-model="item.formular" placeholder="指标" v-if="item.type == 'target'"
                    @change="handleFormularChange" showSearch :dropdownMatchSelectWidth="false"
                    :filter-option="filterOption"
                  >
                    <a-select-option v-for="item in metricsList" :label="item.name" :key="item.field"
                      :value="item.field"  :disabled="item.status !== 1"
                    >{{item.name}}</a-select-option>
                  </a-select>
                  <a-select v-model="item.formular" placeholder="操作符" v-if="item.type == 'op'"
                    @change="handleFormularChange"
                  >
                    <a-select-option v-for="item in opSources" :key="item"
                      :value="item"
                    >{{item}}</a-select-option>
                  </a-select>
                </a-col>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="指标公式" required prop="formularStr"
            :rules="[{required: true, message: '指标公式不能为空', trigger: 'change',}]"
          >
            <el-input v-model="form.formularStr" placeholder disabled></el-input>
          </a-form-model-item>
          <a-form-model-item label="指标单位" prop="unit">
            <a-radio-group v-model="form.unit" @change="unitChange">
              <a-radio :value="key" v-for="(val, key) in unitEnum" :key="key">{{val}}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </template>
        <a-form-model-item label="字段选择" prop="sourceField" required v-if="form.regulationEnum !== 'CALCULATE'"
          :rules="[{required: true, message: '字段选择不能为空', trigger: 'change',}]"
        >
          <a-select v-model="form.sourceField" @change="jsonArrayChange"
            placeholder="请选择字段" showSearch :filter-option="filterOption"
          >
            <a-select-option v-for="item in form.regulationEnum === 'ARRAYMATCH'?jsonArrayList:dimensionsList" :key="item.field" :value="item.field" :label="item.name" :disabled="item.status !== 1">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-if="form.regulationEnum === 'SPLIT'">
          <a-form-model-item label="字段示例" prop="sourceValEg" required
            :rules="[{required: true, message: '字段示例不能为空', trigger: 'blur',}]"
          >
            <a-input :rows="2" type="textarea" resize="none" v-model="form.sourceValEg" 
              @change="handleSplitField(true)" @blur="$refs['form'].validateField('sourceValEg')"
              placeholder="请输入字段内容" clearable
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="字段提取" prop="splitter" required>
            分隔符为"<a-select
              v-model="form.splitter"
              placeholder="请选择"
              style="width: 60px"
              @change="handleSplitField(true)"
              :show-search="true"
              :not-found-content="null"
              :show-arrow="false"
              :filter-option="true"
              :autoClearSearchvalue="false"
              @blur="handleBlur"
              @search="handleSearch"
            >
              <a-select-option :value="v" v-for="v in splitterList" :key="v">{{v}}</a-select-option>
            </a-select>"，选择对应区间为:
            <br/>
            <div style="margin-top: 5px">              
              <a-select
                v-model="form.splitType"
                placeholder="请选择"
                style="width: 80px;margin-right: 8px"
                @change="handleSplitField(true)"
              >
                <a-select-option value="0">正数</a-select-option>
                <a-select-option value="1">倒数</a-select-option>
              </a-select>
              <a-form-model-item prop="fromIdx" ref="fromIdx" required class="no-style"
                :rules="[{required: true, message: '区间不能为空', trigger: 'change',}]"
              >
                <a-select v-model="form.fromIdx" placeholder="请选择" style="width: 285px"
                  @change="handlePositionChange" @blur="$refs['form'].validateField('fromIdx')"
                >
                  <a-select-option v-for="item in postionSources" :key="item.toIdx"
                    :value="item.fromIndex"
                  >{{item.label}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
          </a-form-model-item>
        </template>
        <template v-if="form.regulationEnum === 'LOGIC'">
          <a-form-model-item label="字段定义" prop="logicConditions" required>
            <a-row v-for="(item, index) in form.logicConditions" :key="index"
              style="line-height:44px" class="include-division-row"
            >
              <a-col :span="6" class="division-title">{{ form.sourceField || '已选择的字段名称'}}</a-col>
              <a-col :span="2"><label>包含</label></a-col>
              <a-col :span="5">
                <a-form-model-item class="logic-form-item" :prop="'logicConditions.' + index + '.find'"
                  :rule="{ required: true, message: '不能为空', trigger: 'blur',}"
                >
                  <a-input v-model="item.find" style="hegiht: 10%" placeholder="请输入" clearable/>
                </a-form-model-item>
              </a-col>
              <a-col :span="3" style="padding: 0 10px"><label>则记为</label></a-col>
              <a-col a-col :span="5">
                <a-form-model-item class="logic-form-item" :prop="'logicConditions.' + index + '.thenContent'"
                  :rules="{ required: true, message: '不能为空', trigger: 'blur',}"
                >
                  <a-input v-model="item.thenContent" placeholder="请输入" clearable/>
                </a-form-model-item>
              </a-col>
              <i class="el-icon-circle-plus"
                style="font-size: 1.5em;padding: 5px;color: #409eff;cursor: pointer;" 
                @click="handelAddLogicCondition"
              />
              <i class="el-icon-delete" style="font-size: 1.5em;padding: 5px;color: #f56c6c;cursor: pointer;"
                @click="delLogicCondition(index)"
              />
            </a-row>
            <a-row style="margin-bottom: 0">
              <a-col :span="6"  class="division-title"><span>除此之外的记为</span></a-col>
              <a-col :span="6">
                <a-form-model-item prop="elseContent" :rules="{ required: true, message: '不能为空', trigger: 'blur', }">
                  <a-input v-model="form.elseContent" placeholder="请输入" clearable
                    @blur="$refs['form'].validateField('elseContent')"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
        </template>
        <template v-if="form.regulationEnum === 'ARRAYMATCH'">
          <a-form-model-item label="字段示例" prop="sourceValEg"
            :rules="[
              {required: true, message: '字段示例不能为空', trigger: 'blur',},
              {validator: validatorArray, trigger: 'blur'},
            ]"
          >
            <a-input :rows="2" type="textarea" resize="none" v-model="form.sourceValEg" 
              @input="sourceValEgChange"
              placeholder="请输入字段示例" clearable
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="字段内容" required prop="regulationEnum">
            类型为 
            <a-form-model-item class="no-style" prop="matchFieldValue" :rules="[{required: true, message: '类型不能为空', trigger: 'change',}]">
              <a-select v-model="form.matchFieldValue"
                placeholder="请选择" style="width: 300px" @change="matchChange" showSearch
              >
                <a-select-option :value="v" :key="v" v-for="v in matchFieldList">{{v}}</a-select-option>
              </a-select>
            </a-form-model-item> 的
            <a-form-model-item class="no-style" prop="valueField" :rules="[{required: true, message: '字段不能为空', trigger: 'change',}]">
              <a-select v-model="form.valueField" placeholder="请选择" style="width: 100px">
                <a-select-option v-for="item in actionValueList" :key="item"
                  :value="item"
                >{{item}}</a-select-option>
              </a-select> 
            </a-form-model-item>
            <br>命名为 <a-input v-model="form.name" placeholder="默认带出字段名称" disabled style="width: 484px"/>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { getFieldDetail, addField, editField, metricsByTableIds, jsonArrayByTableIds, dimensionsByTableIds, findRecordsetByCode } from "@/api/mediadata"
import PinyinMatch from 'pinyin-match';

// import matchFieldList from "./actionTypes"
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      regulationEnum: {
        'CALCULATE': '数值计算',
        'SPLIT': '文本位置解析',
        'LOGIC': '文本逻辑解析',
        'ARRAYMATCH': '数组提取',
      },
      form: {
        name: '',
        regulationEnum: 'CALCULATE',
        tableIds: [],
        formularStr: '',
        unit: '',
        fromIdx: undefined,
        splitter: '_',
        sourceField: undefined,
        logicConditions: [{ find: "", thenContent: "", value: 1 }],
        elseContent: "",
        valueField: undefined,
        matchFieldValue: undefined,
        sourceValEg: '',
        splitType: '0'
      },
      unitEnum: {
        '': '无',
        'currency': '货币单位',
        'percentage': '%(百分号)',
      },
      tableList: [],
      nowObj: null,
      // 数值计算
      formulaArrays: [],
      opSources: ['+', '-', '*', '/', '(', ')'],
      metricsList: [],
      // 文本位置解析
      postionSources: [],
      dimensionsList: [],
      jsonArrayList: [],
      // 数组提取
      matchFieldList: [],
      actionValueList: [],
      splitterList: ['__', '_', '-']
    };
  },
  props: ['code'],
  methods: {
    unitChange() {
      if(this.form.unit == 'percentage' && this.form.formularStr) {
        this.form.formularStr =`(${this.form.formularStr})*100`
      } else {
        if(this.form.formularStr.slice(-5) === ')*100') {
          this.form.formularStr = this.form.formularStr.slice(1, -5)
        }
      }
    },
    filterOption(inputValue, option) {
      let label = option.componentOptions.propsData.label
      let value = option.componentOptions.propsData.value
      return label.indexOf(inputValue) > -1 || value.indexOf(inputValue) > -1 || PinyinMatch.match(label, inputValue)
    },
    handleSearch(value){
      this.form.splitter = value!=null && value !='' ? value : '_';
    },
    handleBlur(value) {
      if(value) {
        if(this.splitterList.indexOf(value) === -1) {
          this.splitterList.push(value)
        }
        this.form.splitter = value
        this.handleSplitField(true)
      }
    },
    validatorName(rule, value, callback) {
      if(!/^[\a-\z\A-\Z\u4e00-\u9fe5][\a-\z\A-\Z0-9\u4e00-\u9fe5\(\)\_\-\—]+$/.test(value)) {
        callback(new Error('指标名称中英文开头，支持输入中英文、数字、-、— 、_、()不支持标点符号和空格'))
      } else {
        callback()
      }
    },
    init(data) {
      this.visible = true
      this.splitterList = ['__', '_', '-']
      this.$nextTick(() => {
        if(data) {
          this.nowObj = data
          getFieldDetail(data.id).then((res) => {
            let data = res.data
            if(this.splitterList.indexOf(data.regulation.splitter) === -1) {
              this.splitterList.push(data.regulation.splitter)
            }
            this.form = {
              name: data.name,
              regulationEnum: data.regulation.regulationEnum,
              tableIds: data.tableIds,
              formularStr: data.regulation.formula,
              unit: data.unit,
              sourceField: data.fieldDefinition?.sourceField,
              logicConditions: [{ find: "", thenContent: "", value: 1 }],
              elseContent: data.regulation.elseContent,
              valueField: data.regulation.valueField,
              matchFieldValue: data.regulation.matchFieldValue,
              sourceValEg: data.regulation.sourceValEg || '',
              fromIdx: data.regulation.fromIdx,
              splitter: data.regulation.splitter,
              splitType: '0'
            }
            this.nowObj = data
            this.getDimensionsMetrics()
            if(data.regulation.regulationEnum === "LOGIC"){
              this.form.logicConditions = []
              this.iterResolvingLogicRegulation(
                data.regulation,
                this.form.logicConditions
              );
            } else if(data.regulation.regulationEnum === "SPLIT") {
              console.log(this.form.splitType, data.regulation.fromIdx, data.regulation.toIdx)
              if(data.regulation.fromIdx < 0 || data.regulation.toIdx < 0) {
                this.form.splitType = '1'
                this.form.fromIdx = Math.abs(data.regulation.fromIdx)
              }
              this.handleSplitField(false)
            } else if (data.regulation.regulationEnum === "ARRAYMATCH") {
              this.showSource()
            }
          })
          // .finally(() => this.loading = false)
        } else {
          this.nowObj = null
        }
      })
    },
    handleOk(e) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let sourceEnum = {
            'FB': 'facebook',
            'GG': 'google',
          }
          let params = {
            "fieldDefinition": {
              "datasource": sourceEnum[this.code],
              "sourceField": this.form.sourceField,
              // "tbView": "mv_ad_daily_country_insights"
            },
            "name": this.form.name,
            "regulation": {
              "regulationEnum": this.form.regulationEnum,
              "formula": this.form.formularStr,
              "matchField": "action_type",
              "matchFieldValue": this.form.matchFieldValue,
              // "source": "action_values",
              "valueField": this.form.valueField,
              "sourceValEg": this.form.sourceValEg
            },
            "tableIds": this.form.tableIds,
            "unit": this.form.unit,
            "fieldIds": this.nowObj?this.nowObj.fieldIds:undefined
          }
          if(this.form.regulationEnum == "CALCULATE") {
            params.desc = this.form.formularStr
            const targetFields = this.getTargetFields();
            if (!this.checkIsFormula(this.form.formularStr, targetFields)) {
              this.$message.error("指标公式验证不通过，请确认公式是否正确");
              return false;
            }
          } else if (this.form.regulationEnum == "SPLIT") {
            params.regulation.fromIdx = this.form.splitType === '1'?-this.form.fromIdx:this.form.fromIdx
            params.regulation.source = this.form.sourceField;
            params.regulation.splitter = this.form.splitter;
            params.regulation.splitType = this.form.splitType;
            params.regulation.toIdx = params.regulation.fromIdx + (this.form.splitType === '1'?-1:1);
            params.desc = `提取【${this.form.sourceField}】用${this.form.splitter}分割的${this.postionSources[this.form.fromIdx].label}`
          }  else if (this.form.regulationEnum == "LOGIC") {
            const parentContent = {};
            const conditions = [].concat(this.form.logicConditions);
            this.iterGetLogicRegulation(conditions, parentContent);
            params.regulation = parentContent;
            let desc = `${this.form.sourceField}`
            this.form.logicConditions.forEach(v => {
              desc += `包含“${v.find}”的记为“${v.thenContent}”，`
            })
            params.desc = `${desc}其他的记为“${this.form.elseContent}”`;
          } else if(this.form.regulationEnum === "ARRAYMATCH") {
            params.regulation.source = this.form.sourceField;
            params.desc = `类型为${this.form.matchFieldValue}的${this.form.valueField}`
          }
          this.confirmLoading = true;
          let api = this.nowObj?editField:addField
          api(params).then((res) => {
            if(!this.nowObj) {
              gtag('event', 'create_field', {
                field_name: this.form.name,
              });	
            }
            this.$message.success(`${this.nowObj?'编辑':`该指标在${this.form.tableIds.length}个数据集中创建`}成功！`)
            this.visible = false
            this.reset()
            this.$emit('success')
          }).finally(() => this.confirmLoading = false)
        } else {
          return false;
        }
      });
    },
    // 递归获取逻辑规则
    iterGetLogicRegulation(conditions, parentContent) {
      const condition = conditions.shift();
      parentContent.find = condition.find;
      parentContent.thenContent = condition.thenContent;
      parentContent.regulationEnum = "LOGIC";
      parentContent.source = this.form.sourceField;
      if (conditions.length == 0) {
        parentContent.elseContent = this.form.elseContent;
        return parentContent;
      } else {
        parentContent.elseRegulationDefinition = {};
        return this.iterGetLogicRegulation(
          conditions,
          parentContent.elseRegulationDefinition
        );
      }
    },
    handleCancel(e) {
      console.log(this.form)
      this.reset()
      this.visible = false;
    },
    reset() {
      this.form = {
        name: '',
        regulationEnum: 'CALCULATE',
        tableIds: [],
        formularStr: '',
        unit: '',
        fromIdx: undefined,
        splitter: '_',
        sourceField: undefined,
        logicConditions: [{ find: "", thenContent: "", value: 1 }],
        elseContent: "",
        valueField: undefined,
        matchFieldValue: undefined,
        sourceValEg: '',
        splitType: '0'
      }
      this.formulaArrays = []
      this.jsonArrayList = []
      this.metricsList = []
      this.dimensionsList = []
      this.$refs.form.clearValidate()
    },
    handleClearValidate() {
      this.$refs["form"].clearValidate([
        'formularStr',
        'sourceField',
        'sourceValEg',
        'fromIdx',
      ]);
    },
    // 字段类型change
    regulationChange() {
      // 数值计算
      this.formulaArrays = []
      this.form.formularStr = ''
      this.form.unit = ''
      // 文本位置
      this.postionSources = []
      this.form.sourceField = undefined
      this.form.sourceValEg = ''
      this.form.splitter = '_'
      this.form.splitType = '0'
      this.form.fromIdx = undefined
      // 文本逻辑
      this.form.logicConditions = [{ find: "", thenContent: "", value: 1 }]
      this.form.elseContent = ''
      // 数组提取
      this.form.sourceField = undefined
      this.form.matchFieldValue = undefined
      this.form.valueField = undefined
      this.handleClearValidate()
    },
    // 数值计算
    handleAddTargetSelect() {
      let formular = { name: "指标", type: "target", formular: undefined };
      this.formulaArrays.push(formular);
    },
    handleFormularChange() {
      let formularS = "";
      this.formulaArrays.forEach((data) => {
        formularS = formularS + (data.formular || '');
      });
      this.form.formularStr = formularS;
      if(this.form.unit === 'percentage') {
        this.form.unit = ''
      }
      this.$refs.form.validateField('formularStr')
    },
    handleAddOpSelect() {
      let formular = { name: "操作符", type: "op", formular: undefined };
      this.formulaArrays.push(formular);
    },
    handleFormulaOpInput() {
      let formular = { name: "输入框", type: "input", formular: '' };
      this.formulaArrays.push(formular);
    },
    handleDelFormulaOp() {
      this.formulaArrays.pop();
      this.handleFormularChange();
    },
    getTargetFields() {
      const targetFields = {};
      this.metricsList.forEach((item) => {
        targetFields[item.field] = 1;
      });
      return targetFields;
    },
    checkIsFormula(string, obj) {
      // 剔除空白符
      string = string.replace(/\s/g, "");
      // 错误情况，空字符串
      if (string === "") {
        return false;
      }
      // 错误情况，运算符连续
      if (/[\+\-\*\/]{2,}/.test(string)) {
        return false;
      }
      // 空括号
      if (/\(\)/.test(string)) {
        return false;
      }
      // 错误情况，括号不配对
      var stack = [];
      for (var i = 0, item; i < string.length; i++) {
        item = string.charAt(i);
        if (item === "(") {
          stack.push("(");
        } else if (item === ")") {
          if (stack.length > 0) {
            stack.pop();
          } else {
            return false;
          }
        }
      }
      if (stack.length !== 0) {
        return false;
      }
      // 错误情况，(后面是运算符
      if (/\([\+\-\*\/]/.test(string)) {
        return false;
      }
      // 错误情况，)前面是运算符
      if (/[\+\-\*\/]\)/.test(string)) {
        return false;
      }
      // 错误情况，(前面不是运算符
      if (/[^\+\-\*\/]\(/.test(string)) {
        return false;
      }
      // 错误情况，)后面不是运算符
      if (/\)[^\+\-\*\/]/.test(string)) {
        return false;
      }
      // 错误情况，不能以+-*/(结尾
      if (!(/.*(?<![\-,\+,\*,/,\(])$/.test(string))) {
        return false;
      }
      // 错误情况，不能以+-*/)开头
      if (/^[\+\-\*\/\)]/.test(string)) {
        return false;
      }
      // 错误情况，变量没有来自“待选公式变量”
      var tmpStr = string.replace(/[\(\)\+\-\*\/]{1,}/g, "`");
      var array = tmpStr.split("`");
      for (var i = 0, item; i < array.length; i++) {
        item = array[i];
        if (/[A-Z]/i.test(item) && typeof obj[item] === "undefined") {
          return false;
        }
      }
      return true;
    },
    // 文本位置解析
    handleSplitField(resetFromIdx = true) {
      this.postionSources = [];
      if (this.form.sourceValEg) {
        let fields = this.form.sourceValEg.split(this.form.splitter).filter(v => v !== '');
        if (fields.length > 0) {
          if(this.form.splitType === "0") {
            for (var i = 0; i < fields.length; i++) {
              let item = {
                fromIndex: i,
                toIndex: i + 1,
                label: "第" + i + "至第" + (i + 1) + "位置:" + fields[i],
              };
              this.postionSources.push(item);
            }
          } else {
              for (var i = 0; i < fields.length; i++) {
              let item = {
                fromIndex: i,
                toIndex: i + 1,
                label: "第" + i + "至第" + (i + 1) + "位置:" + fields[fields.length-i-1],
              };
              this.postionSources.push(item);
            }
          }
        }
      }
      if (resetFromIdx) {
        // this.$nextTick(() => {
        this.form.fromIdx = undefined
        this.$refs["form"].clearValidate('fromIdx');
        // });
      }
    },
    handlePositionChange(val) {
      this.$forceUpdate();
    },
    // 获取指标和维度
    async tableIdChange() {
      this.metricsList = []
      this.dimensionsList = []
      this.jsonArrayList = []
      this.matchFieldList = []
      this.actionValueList = []
      this.regulationChange()
      if(this.form.tableIds.length) this.getDimensionsMetrics();
    },
    getDimensionsMetrics() {
      metricsByTableIds(this.form.tableIds).then((res) => {
        this.metricsList = res.data;
      })
      dimensionsByTableIds(this.form.tableIds).then((res) => {
        this.dimensionsList = res.data;
      })
      jsonArrayByTableIds(this.form.tableIds).then((res) => {
        this.jsonArrayList = res.data;
      })
    },
    // 文本逻辑解析
    handelAddLogicCondition() {
      const condition = {
        find: "",
        thenContent: "",
        value: this.form.logicConditions.length + 1,
      };
      this.form.logicConditions.push(condition);
    },
    delLogicCondition(index) {
      if (this.form.logicConditions.length > 1) {
        this.form.logicConditions.splice(index, 1);
      }
    },
    iterResolvingLogicRegulation(regulation, logicConditions) {
      const item = {
        find: regulation.find,
        thenContent: regulation.thenContent,
        value: this.form.logicConditions.length + 1,
      };
      logicConditions.push(item);
      if (regulation.elseRegulationDefinition) {
        return this.iterResolvingLogicRegulation(
          regulation.elseRegulationDefinition,
          logicConditions
        );
      } else {
        this.form.elseContent = regulation.elseContent;
        return;
      }
    },
    // 数组提取
    validatorArray(rule, value, callback) {
      try {
        let arr = JSON.parse(value)
        if(arr.length) {
          callback()
        } else {
          callback(new Error('数组长度不能为零'))
        }
      } catch (error) {
        callback(new Error('数据格式不正确'))
      }
    },
    jsonArrayChange(val) {
      this.form.matchFieldValue = undefined
      this.form.valueField = undefined
      this.actionValueList = []
      if(this.form.regulationEnum === "ARRAYMATCH"&&val) {
        let obj = this.jsonArrayList.find(v => v.field === val)
        if(obj) {
          this.form.sourceValEg = obj.example
          this.sourceValEgChange()
        }
      }
    },
    showSource() {
      try {
        let arr = JSON.parse(this.form.sourceValEg)
        this.matchFieldList = arr.map(v => v.action_type)
        let obj = arr.find(v => v.action_type === this.form.matchFieldValue)
        this.actionValueList = Object.keys(obj).filter(v => v !== 'action_type')
      } catch (error) {
        console.log(error)      
      }
    },
    sourceValEgChange(val) {
      this.form.matchFieldValue = undefined
      this.matchFieldList = []
      try {
        let arr = JSON.parse(this.form.sourceValEg)
        this.matchFieldList = arr.map(v => v.action_type)
      } catch (error) {
        console.log(error)      
      }
    },
    matchChange(val) {
      if(this.form.sourceValEg) {
        console.log(val)
        try {
          let arr = JSON.parse(this.form.sourceValEg)
          console.log(arr)
          let obj = arr.find(v => v.action_type === val)
          this.actionValueList = Object.keys(obj).filter(v => v !== 'action_type')
          console.log(Object.keys(obj))
        } catch (error) {
          console.log(error)      
        }
      }
    }
  },
  mounted() {
    findRecordsetByCode({
      code: this.code
    }).then((res) => {
      this.tableList = res.data || []
    })
  }
};
</script>
<style lang="less" scoped>
.division-title {
  text-align: left;
  line-height: 40px;
  padding-right: 10px;
}
.delete-info {
  font-size: 16px;
  vertical-align: middle;
  margin-left: 10px;
}
.add-fields-modal{
  .top-info {
    padding-left: 90px;
    margin-top: -20px;
    margin-bottom: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #2D3446;
    background: #cfddff;
    padding: 10px;
    border-radius: 5px;
    .anticon {
      color: #4278ff;
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
</style>